module.exports = __webpack_public_path__ + "static/Gotham-XLightItalic-395486206834743d9d00c6e4a45066dd.ttf";